/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import TagsApi from '../api/Tags';
import * as ActionTypes from './ActionTypes';
import { showErrorNotification, showSuccessNotification } from './Notifications';
function tagsReceived(payload) {
  return {
    type: ActionTypes.FETCH_TAG_DEFINITIONS_SUCCESS,
    payload
  };
}
function tagsRequesting() {
  return {
    type: ActionTypes.FETCH_TAG_DEFINITIONS_PENDING
  };
}
function tagsRequestFailed(error) {
  return {
    type: ActionTypes.FETCH_TAG_DEFINITIONS_ERROR,
    error
  };
}
export function getTags(knowledgeBaseId) {
  return dispatch => {
    dispatch(tagsRequesting());
    TagsApi.get(knowledgeBaseId).then(response => dispatch(tagsReceived(response)), error => {
      dispatch(showErrorNotification('getTags'));
      dispatch(tagsRequestFailed(error));
    });
  };
}
function applyingTagToArticles() {
  return {
    type: ActionTypes.APPLY_TAG_TO_ARTICLES_PENDING
  };
}
function applyTagToArticlesSuccess(response, contentIds) {
  return {
    type: ActionTypes.APPLY_TAG_TO_ARTICLES_SUCCESS,
    payload: response,
    articleIds: contentIds
  };
}
function applyTagToArticlesError(error) {
  return {
    type: ActionTypes.APPLY_TAG_TO_ARTICLES_ERROR,
    error
  };
}
export function applyTagToArticles(tagName, tagId, associatedArticles, knowledgeBaseId) {
  return dispatch => {
    dispatch(applyingTagToArticles());
    const contentIds = associatedArticles.map(article => article.values.hs_id).toArray();
    const tagData = {
      name: tagName,
      contentIds,
      knowledgeBaseId
    };
    return (tagId ? TagsApi.update(tagId, tagData) : TagsApi.create(tagData)).then(res => {
      dispatch(applyTagToArticlesSuccess(res, contentIds));
      dispatch(showSuccessNotification('applyTagToArticles'));
    }, err => {
      dispatch(showErrorNotification('applyTagToArticles'));
      dispatch(applyTagToArticlesError(err));
    });
  };
}
export function tagArticlesWithTerm(searchTerm) {
  return {
    type: ActionTypes.TAG_ARTICLES_WITH_TERM,
    payload: {
      searchTerm
    }
  };
}
export function tagArticlesWithTermComplete() {
  return {
    type: ActionTypes.TAG_ARTICLES_WITH_TERM_COMPLETE
  };
}